// Create an object to hold your images categorized by type
const imgs = {
  png: {},
  jpg: {},
  svg: {},
};

// Dynamically import images from the current folder.
// Vite: import.meta.glob replaces webpack's require.context.
const imageModules = import.meta.glob("./*.{png,jpg,jpeg,svg}", {
  eager: true,
  import: "default",
});

Object.entries(imageModules).forEach(([key, importedImage]) => {
  // Remove the "./" from the beginning of the key and use it as the property name
  const formattedKey = key.replace("./", "");

  // Get the file extension
  const extension = formattedKey
    .split(".")
    .pop()
    .toLowerCase();

  // Remove the extension from the key to use it as the property name
  const propertyName = formattedKey.replace(`.${extension}`, "");

  // Convert hyphens to underscores to make it a valid JavaScript identifier
  const validPropertyName = propertyName.replace(/-/g, "_");

  if (["png", "jpg", "svg"].includes(extension)) {
    imgs[extension][validPropertyName] = importedImage;
  }
});

export default imgs;
